/** Supabase `mfa.listFactors()` payload (shape varies slightly by SDK version). */
export function pickFactorForChallenge(factors: {
  totp?: Array<{ id: string; status?: string }>;
  all?: Array<{ id: string; status?: string; factor_type?: string }>;
} | null | undefined): { id: string; factorType: 'totp' | 'webauthn' } | null {
  if (!factors) return null;
  const totp = factors.totp?.find((f) => f.status === 'verified');
  if (totp?.id) return { id: totp.id, factorType: 'totp' };
  const all = factors.all ?? [];
  const web = all.find(
    (f) => f.status === 'verified' && f.factor_type === 'webauthn',
  );
  if (web?.id) return { id: web.id, factorType: 'webauthn' };
  return null;
}

export async function needsMfaStep(mfa: {
  getAuthenticatorAssuranceLevel?: () => Promise<{
    data: { currentLevel: string; nextLevel: string } | null;
    error: Error | null;
  }>;
}): Promise<boolean> {
  if (!mfa?.getAuthenticatorAssuranceLevel) return false;
  const { data, error } = await mfa.getAuthenticatorAssuranceLevel();
  if (error || !data) return false;
  return data.currentLevel === 'aal1' && data.nextLevel === 'aal2';
}
